import React from 'react';
import PropTypes from 'prop-types';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { ApplicationWrapper } from 'containers/ApplicationWrapper';
import CookiesProvider from 'react-cookie/lib/CookiesProvider';
import { OptimizelyProvider } from '@optimizely/react-sdk';

Bugsnag.start({
	apiKey: process.env.BUGSNAG_CLIENT_KEY,
	plugins: [new BugsnagPluginReact()],
});

const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);

import '../main.scss';

export const App = ({ store, optimizelyClient, optimizelyUser }) => {
	const {
		user: { visitId },
	} = store.getState();
	const user = optimizelyUser || { id: visitId };
	return (
		<Provider store={store}>
			<OptimizelyProvider
				optimizely={optimizelyClient}
				user={user}
			>
				<ErrorBoundary>
					<CookiesProvider>
						<BrowserRouter>
							<ApplicationWrapper />
						</BrowserRouter>
					</CookiesProvider>
				</ErrorBoundary>
			</OptimizelyProvider>
		</Provider>
	);
};

App.propTypes = {
	store: PropTypes.object,
	optimizelyClient: PropTypes.object,
	optimizelyUser: PropTypes.shape({
		id: PropTypes.string,
		attributes: PropTypes.object,
	}),
};

App.defaultProps = {
	optimizelyClient: null,
	optimizelyUser: null,
};

export default hot(module)(App);
